import React from "react";
import NFLookupEmptyForms from "../../../Shared/NewForms/NFLookupEmptyForms";

function FixedAssetsWriteOffsGenericSkeleton() {
  return (
    <>
      <NFLookupEmptyForms />
    </>
  );
}

export default FixedAssetsWriteOffsGenericSkeleton;
